(function (window) {
    "use strict";
    function defineLocalStorageCacheHelper() {
        let localStorageCacheHelper = {};
        localStorageCacheHelper.localStorageKey = {
            zonesKey: "zones",
            zonesInactiveKey: "zonesInactive",
            shippingAreasKey: "shippingAreas",
            shippingAreasInactiveKey: "shippingAreasInactive",
            provincesKey: "provinces",
            driversKey: "drivers",
            driversInactiveKey: "driversInactive",
            vehiclesKey: "vehicles",
            vehiclesInactiveKey: "vehiclesInactive",
            deliveryProcessFlagsKey: "deliveryProcessFlags"
        };
        localStorageCacheHelper.getDataPost = function (apiUrl, fieldsToFilterBy, request, localStorageKey, getFromApi){
            return new Promise((resolve, reject) => {
                let dataInLocalStorage = localStorage.getItem(localStorageKey);
                console.log("getFromApi", getFromApi);
                if(dataInLocalStorage === null || getFromApi){
                    postToApi(apiUrl, request).then(
                        successResponse => {
                            if(successResponse.data.responseStatus === responseStatus.status.successful){
                                if(successResponse.data.result !== null && successResponse.data.result.length > 0){
                                    let data = {
                                        data: successResponse.data,
                                        dateOfCache: new Date()
                                    };
                                    localStorage.setItem(localStorageKey, JSON.stringify(data))
                                }
                            }
                            resolve(successResponse);
                        },
                        errorResponse => {
                            reject(errorResponse);
                        }
                    );
                }
                else{
                    let data = JSON.parse(dataInLocalStorage);
                    let dateNow = new Date();
                    let dateLastCached = new Date(data.dateOfCache);
                    let minutesSinceLastCacheUpdate = getDifferenceBetweenDatesInMinutes(dateNow, dateLastCached);
                    if(minutesSinceLastCacheUpdate >= 60){
                        // get data from api and cache
                        postToApi(apiUrl, request).then(
                            successResponse => {
                                if(successResponse.data.responseStatus === responseStatus.status.successful){
                                    if(successResponse.data.result !== null && successResponse.data.result.length > 0){
                                        let data = {
                                            data: successResponse.data,
                                            dateOfCache: new Date()
                                        };
                                        localStorage.setItem(localStorageKey, JSON.stringify(data))
                                    }
                                    else{
                                        localStorage.removeItem(localStorageKey);
                                    }
                                }
                                resolve(successResponse);
                            },
                            errorResponse => {
                                reject(errorResponse);
                            }
                        );
                    }
                    else{
                        console.log("data", data);
                        data.data.result = filterData(fieldsToFilterBy, data.data);
                        resolve(data);
                    }
                }
            });
        };
        localStorageCacheHelper.getDataViaGet = function (apiUrl, localStorageKey, fieldsToFilterBy, howLongToKeepCachedInMinutes){
            return new Promise((resolve, reject) => {
                let dataInLocalStorage = localStorage.getItem(localStorageKey);
                if(dataInLocalStorage === null){
                    httpGetFromApi(apiUrl).then(
                        successResponse => {
                            if(successResponse.data.responseStatus === responseStatus.status.successful){
                                if(successResponse.data.result !== null){
                                    let data = {
                                        data: successResponse.data,
                                        dateOfCache: new Date()
                                    };
                                    localStorage.setItem(localStorageKey, JSON.stringify(data))
                                }
                                else{
                                    localStorage.removeItem(localStorageKey);
                                }
                            }
                            resolve(successResponse);
                        },
                        errorResponse => {
                            reject(errorResponse);
                        }
                    );
                }
                else{
                    let keepCachedForInMinutes = 60;
                    if(howLongToKeepCachedInMinutes !== null && howLongToKeepCachedInMinutes !== undefined){
                        if(howLongToKeepCachedInMinutes > 0){
                            keepCachedForInMinutes = howLongToKeepCachedInMinutes;
                        }
                    }
                    let data = JSON.parse(dataInLocalStorage);
                    let dateNow = new Date();
                    let dateLastCached = new Date(data.dateOfCache);
                    let minutesSinceLastCacheUpdate = getDifferenceBetweenDatesInMinutes(dateNow, dateLastCached);
                    if(minutesSinceLastCacheUpdate >= keepCachedForInMinutes){
                        // get data from api and cache
                        httpGetFromApi(apiUrl).then(
                            successResponse => {
                                if(successResponse.data.responseStatus === responseStatus.status.successful){
                                    if(successResponse.data.result !== null && successResponse.data.result.length > 0){
                                        let data = {
                                            data: successResponse.data,
                                            dateOfCache: new Date()
                                        };
                                        localStorage.setItem(localStorageKey, JSON.stringify(data))
                                    }
                                }
                                resolve(successResponse);
                            },
                            errorResponse => {
                                reject(errorResponse);
                            }
                        );
                    }
                    else{
                        console.log("data", data);
                        if(fieldsToFilterBy !== null && fieldsToFilterBy !== undefined && fieldsToFilterBy.length > 0){
                            data.data.result = filterData(fieldsToFilterBy, data.data);
                        }
                        resolve(data);
                    }
                }
            })
        };
        localStorageCacheHelper.removeItemFromCache = function (objectKeyForId, id, localStorageKey){
            var dataInLocalStorage = localStorage.getItem(localStorageKey);
            if(dataInLocalStorage !== null){
                var data = JSON.parse(dataInLocalStorage);
                for(var i = 0; i < data.data.result.length; i++){
                    if(data.data.result[i][objectKeyForId] === id){
                        data.data.result.splice(i, 1);
                        break;
                    }
                }
                localStorage.setItem(localStorageKey, JSON.stringify(data));
            }
        }
        
        // otp form cache
        localStorageCacheHelper.setOtpFormCache = function (instanceId, localStorageKey, otpDone){
            let instanceIdStorage = {
                instanceId: instanceId,
                date: new Date(),
                otpDone: false
            };
            if(otpDone){
                instanceIdStorage.otpDone = true;
            }
            localStorage.setItem(localStorageKey, JSON.stringify(instanceIdStorage));
        }
        
        localStorageCacheHelper.getOtpFormCache = function (localStorageKey){
            let instanceIdStorage = JSON.parse(localStorage.getItem(localStorageKey));
            if(instanceIdStorage === null){
                return null;
            }
            let dateNow = new Date();
            let dateLastCached = new Date(instanceIdStorage.date);
            let minutesSinceLastCacheUpdate = getDifferenceBetweenDatesInMinutes(dateNow, dateLastCached);
            if(minutesSinceLastCacheUpdate > 15){
                localStorage.removeItem(localStorageKey);
                return null;
            }
            return instanceIdStorage;
        };

        localStorageCacheHelper.removeOtpFormCache = function (localStorageKey){
            localStorage.removeItem(localStorageKey);
        };
        
        function filterData(fieldsToFilterBy, data){
            // var filteredData = data.result.filter(values =>{
            //    
            // })
            let filteredData = [];
            for(let i = 0; i < data.result.length; i++){
                let canIncludeInFilteredList = false;
                //var keys = Object.keys(data.result[i]);
                for(let j = 0; j < fieldsToFilterBy.length; j++){
                    // if(fieldsToFilterBy[j].value !== null && fieldsToFilterBy[j].value !== undefined && fieldsToFilterBy[j].value !== ""){
                    //     if(data.result[i][fieldsToFilterBy[j].key] === fieldsToFilterBy[j].value){
                    //         canIncludeInFilteredList = true;
                    //     }
                    // }
                    if(String(data.result[i][fieldsToFilterBy[j].key]).toLowerCase().includes(String(fieldsToFilterBy[j].value).toLowerCase())){
                        canIncludeInFilteredList = true;
                    }
                }
                console.log("canIncludeInFilteredList", canIncludeInFilteredList);
                if(canIncludeInFilteredList){
                    filteredData.push(data.result[i]);
                    canIncludeInFilteredList = false;
                }
            }
            if(filteredData.length === 0){
                return data.result;
            }
            return filteredData;
        }
        
        function postToApi(url, request){
            return axios.post(url, request);
        }
        function httpGetFromApi(url){
            return axios.get(url);
        }
        function getDifferenceBetweenDatesInMinutes(date1, date2){
            return Math.abs(Math.round((date2.getTime() - date1.getTime()) / 60000));
        }
        return localStorageCacheHelper;
    }
    //define globally if it doesn't already exist
    if (typeof (localStorageCacheHelper) === "undefined") {
        window.localStorageCacheHelper = defineLocalStorageCacheHelper();
    } else {
        console.log("localStorageCacheHelper already defined.");
    }
})(window);